import { render, staticRenderFns } from "./tenderAgent.vue?vue&type=template&id=6d2831b4&scoped=true&"
import script from "./tenderAgent.vue?vue&type=script&lang=js&"
export * from "./tenderAgent.vue?vue&type=script&lang=js&"
import style0 from "./tenderAgent.vue?vue&type=style&index=0&id=6d2831b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2831b4",
  null
  
)

export default component.exports